export enum GuardDutyFeature {
  S3DataEvents = 'S3_DATA_EVENTS',
  EksAuditLogs = 'EKS_AUDIT_LOGS',
  EbsMalwareProtection = 'EBS_MALWARE_PROTECTION',
  RdsLoginEvents = 'RDS_LOGIN_EVENTS',
  LambdaNetworkLogs = 'LAMBDA_NETWORK_LOGS',
  CloudTrail = 'CLOUD_TRAIL',
  DnsLogs = 'DNS_LOGS',
  FlowLogs = 'FLOW_LOGS',
  RmEksAddonManagement = 'RUNTIME_MONITORING.EKS_ADDON_MANAGEMENT',
  RmEcsFargateAgentManagement = 'RUNTIME_MONITORING.ECS_FARGATE_AGENT_MANAGEMENT',
  RmEc2AgentManagement = 'RUNTIME_MONITORING.EC2_AGENT_MANAGEMENT',
}
